export default [
  {
    name: 'Monthly',
    value: 'MONTHLY',
  },
  {
    name: 'End of Hire',
    value: 'END_OF_HIRE',
  },
];
